import { payloadToJSON } from '@tock/coretypes';
import { tocktix as tocktixCore } from '@tock/protos/dist/types/core';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

const initialState = {
  isInitialized: false,
  metroAreaList: [],
  metroArea: null,
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.METRO_AREA_GET_ALL_STARTING:
    case ClowncarAppConstants.METRO_AREA_UPDATE_STARTING:
    case ClowncarAppConstants.METRO_AREA_UPDATE_IMAGE_STARTING:
    case ClowncarAppConstants.METRO_AREA_INSERT_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.METRO_AREA_GET_ALL_DONE: {
      return {
        ...state,
        requestInProgress: false,
        metroAreaList: payloadToJSON<tocktixCore.messages.MetroArea[]>(payload),
        isInitialized: true,
      };
    }
    case ClowncarAppConstants.METRO_AREA_SELECT: {
      return {
        ...state,
        metroArea: payload,
      };
    }
    case ClowncarAppConstants.METRO_AREA_UPDATE_DONE: {
      return {
        ...state,
        metroArea: payloadToJSON<tocktixCore.messages.MetroArea>(payload),
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.METRO_AREA_UPDATE_IMAGE_DONE:
    case ClowncarAppConstants.METRO_AREA_UPDATE_IMAGE_FAILED:
    case ClowncarAppConstants.METRO_AREA_GET_ALL_FAILED:
    case ClowncarAppConstants.METRO_AREA_UPDATE_FAILED:
    case ClowncarAppConstants.METRO_AREA_INSERT_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    default:
      return state;
  }
}
